import { useEffect } from "react";
/**
 * Custom hook to manage the integration of a live chat widget.
 *
 * This hook dynamically inserts a live chat script into the DOM and ensures it is reloaded periodically.
 * It also cleans up the script when the component using this hook is unmounted.
 */
export const useLiveChat = () => {
  useEffect(() => {
    const clearScripts = () => {
      document.getElementById("scriptid")?.remove();
      document.getElementById("zsiqscript")?.remove();
    };

    const insertScript = () => {
      if (
        document.getElementById("scriptid") &&
        document.getElementById("zsiqscript")
      ) {
        clearScripts();
      }
      const script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "scriptid");
      script.async = true;

      const code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "siq7b375e6e29e57c287adce25599f9910046b93a0be234a7db00af173d9448be4b975d7e2ebba20b9be092d1276f8790a6", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zohopublic.eu/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`;
      script.appendChild(document.createTextNode(code));
      document.body.appendChild(script);
    };
    const interval = setInterval(insertScript, 60000);
    insertScript();
    return () => {
      clearInterval(interval);
      clearScripts();
    };
  }, []);
};
